import React from "react";
import { Diamond, BookOpen, Heart, TrendingUp, ShieldCheck } from "lucide-react";

const valeurs = [
  { icon: <Diamond size={18} />, label: "Élégance" },
  { icon: <BookOpen size={18} />, label: "Pédagogie" },
  { icon: <Heart size={18} />, label: "Plaisir" },
  { icon: <TrendingUp size={18} />, label: "Progression" },
  { icon: <ShieldCheck size={18} />, label: "Confiance" },
];

export const APropos = () => {
  return (
    <section id="a-propos" data-testid="a-propos-section" className="py-24 md:py-32 bg-[#F7F3EA]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-14 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <div className="flex items-center gap-3 mb-5">
            <span className="h-px w-10 bg-[#C9A869]" />
            <span className="text-[11px] tracking-[0.4em] uppercase text-[#C9A869]">À propos</span>
          </div>
          <h2 className="serif font-light text-4xl md:text-5xl lg:text-6xl text-[#2B2B31] tracking-tight leading-[1.05]">
            La danse comme un <span className="italic" style={{ color: "#C9A869" }}>art de vivre</span>.
          </h2>

          <div className="mt-12 space-y-3">
            <p className="text-[10px] tracking-[0.4em] uppercase text-[#C9A869] mb-4">Mes valeurs</p>
            {valeurs.map((v, i) => (
              <div key={i} className="flex items-center gap-4 py-3 border-b border-[#2B2B31]/10">
                <div className="w-9 h-9 flex items-center justify-center border border-[#C9A869]/50 text-[#C9A869]">
                  {v.icon}
                </div>
                <span className="serif text-2xl text-[#2B2B31]">{v.label}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="lg:col-span-7 space-y-6 text-[#2B2B31]/85 leading-relaxed font-light text-base md:text-lg">
          <p>
            Je suis professeur de rock et de valse depuis plusieurs années. J'ai donné de nombreux cours particuliers et collectifs, en accompagnant aussi bien des débutants complets que des danseurs souhaitant progresser rapidement.
          </p>
          <p>
            J'ai beaucoup pratiqué dans les soirées rock à Paris et Versailles, et j'enseigne aujourd'hui en France et au Luxembourg.
          </p>
          <p className="serif italic text-2xl md:text-3xl text-[#2B2B31] border-l-2 border-[#C9A869] pl-6 py-2">
            « Pour moi, la danse doit rester un plaisir. Mon rôle est de vous donner les bons repères techniques, de vous aider à trouver votre style, et de vous permettre de danser avec confiance, sans rigidité ni stress. »
          </p>
          <p className="text-right text-[#C9A869] tracking-[0.2em] uppercase text-xs">— Louis-Melchior</p>
        </div>
      </div>
    </section>
  );
};
